import { render, staticRenderFns } from "./Scrolldown.vue?vue&type=template&id=5d502f62&scoped=true"
import script from "./Scrolldown.vue?vue&type=script&lang=js"
export * from "./Scrolldown.vue?vue&type=script&lang=js"
import style0 from "./Scrolldown.vue?vue&type=style&index=0&id=5d502f62&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d502f62",
  null
  
)

export default component.exports